import axios from 'axios';
import { env, storage_keys } from '../../constant/configs';

import { i18n } from '@/i18n-config';

const instance = axios.create({
  baseURL: env.api_url + '',
});

const isServer = typeof window === 'undefined';

instance.interceptors.request.use(async (config) => {
  if (isServer) {
    const { headers } = await import('next/headers');
    const headersList = await headers();
    const pathname = headersList.get('x-invoke-path') || '';

    i18n.locales.forEach((value) => {
      if (pathname.startsWith(`/${value}`)) {
        config.headers['Accept-Language'] = value;
        return;
      }
    });
  } else {
    const impId = localStorage.getItem(storage_keys.res_impersonate_id);
    if (impId) {
      config.headers['x-proxy-user-id'] = impId;
    }

    // Set timezone header
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers['User-Timezone'] = timezone;

    const pathname = window.location.pathname;

    i18n.locales.forEach((value) => {
      if (pathname.startsWith(`/${value}`)) {
        config.headers['Accept-Language'] = value;
        return;
      }
    });
  }

  return config;
});

export default instance;
